
module.exports = {
	context: {
		title: 'Nyhet', 
		header: 'Vi upphandlar tvätt och reparation av soldatmateriel samt sömnad.', 
		content:'Vi uppskattar avancerade helikoptrar, ubåtar och flygplan. Och vi tar vårt uppdrag att leverera materiel och tjänster till Sveriges försvar på största allvar. Men vi är mycket mer än så. Vi är ett av Sveriges bästa karriärföretag.', 
		date:'19-01-28',
		url:'#', 
		bgColor:'medium-grey',
		bgImage:'',
	}
};
